import { PathSolver } from 'my-account-common'

class Config {
  constructor () {
    let envPath = PathSolver.getPathForWebEnvironment()
    if (envPath === '') {
      envPath = 'www'
    }
    this.validateMemberUrl = 'https://webservice' + PathSolver.getPathForEnvironment() +
      '.24hourfitness.com/api/rest/myaccount-validate-member-process/ValidateMember'
    this.validateUsernameUrl = 'https://webservice' + PathSolver.getPathForEnvironment() +
      '.24hourfitness.com/api/rest/myaccount-validate-username-process/ValidateUsername'
    this.registerMemberUrl = 'https://webservice' + PathSolver.getPathForEnvironment() +
      '.24hourfitness.com/api/rest/myaccount-user-registration-process/UserRegistration'

    // Links for button redirection
    this.memberLoginUrl = '/login.html'
    this.myProfileUrl = '/myaccount/profile.html'
    this.contactUsUrl = 'https://' + envPath + '.24hourfitness.com/contact_us'
  }
}
let cfg = new Config()
export default cfg



// WEBPACK FOOTER //
// ./src/services/configuration/PropertiesConfiguration.js